import MyBetsHistory from './MyBetsHistory';
export default MyBetsHistory;